'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SearchOutlined = require('./lib/icons/SearchOutlined');
  
  
  var _default = _SearchOutlined;
  exports.default = _default;
  module.exports = _default;